module.exports = __webpack_public_path__ + "media/src/images/abouts/items/stores/ichiran_1-c92c74203b575b577aec67d75e790902.jpg";